module.exports = "<span *ngIf=\"this.selection\">Asset#: {{ this.selection.slice(-5) }}<ng-container *ngFor=\"let key of this.tags; index as i\"><input class=\"reset\" (click)=\"this.editor.resetValue($event.target.value)\" type=\"button\" value=\"{{key}}\" id=\"{{key}}\"></ng-container></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/asset-tags/asset-tags.component.pug
// module id = 1157
// module chunks = 1